import React from "react";

export const cartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="34"
    height="34"
    viewBox="0 0 34 34"
  >
    <defs>
      <path id="b" d="M0 0h1440v64H0z" />
      <filter
        id="a"
        width="101.4%"
        height="131.2%"
        x="-.7%"
        y="-12.5%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="3"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.878431373 0 0 0 0 0.88627451 0 0 0 0 0.890196078 0 0 0 1 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)">
        <circle
          cx="15.922"
          cy="15.693"
          r="15.68"
          stroke="#666666"
          strokeWidth="1.5"
          fill="#FFFFFF"
        />
        <path
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10.563 11.216h13.025c.09 0 .2.192.255.262.073.07.091.243.055.33l-2.004 6.368c-.11.417-.492.659-.947.659h-7.85c-.456 0-.855-.207-.947-.624 0 0-1.696-6.447-2.003-7.7-.309-1.253-.622-1.773-1.906-1.773"
        />
        <path
          fill="#666666"
          d="M15.801 22.456c0 .766-.65 1.387-1.452 1.387-.802 0-1.451-.62-1.451-1.387 0-.766.649-1.388 1.45-1.388.803 0 1.453.622 1.453 1.388M20.496 22.456c0 .766-.65 1.387-1.452 1.387-.802 0-1.451-.62-1.451-1.387 0-.766.65-1.388 1.451-1.388.802 0 1.452.622 1.452 1.388"
        />
      </g>
    </g>
  </svg>
);